import { LengthUnits } from "convert-units/definitions/length";
import { VolumeFlowRateUnits } from "convert-units/definitions/volumeFlowRate";
import { CRS, LatLng } from "leaflet";
import { flow, types } from "mobx-state-tree";
import fetchTabular from "../api/ng/tabular";

const {
    identifier,
    model,
    number,
    string,
} = types;

interface HasPosition {
    position: LatLng;
}

export type TabularDataOneColumn = Map<Date, number>;
export type TabularDataTwoColumns = Map<Date, [number, number]>;

export type TabularData =
    | { type: "OneColumn"; unit: LengthUnits; rows: TabularDataOneColumn }
    | {
        type: "TwoColumns";
        units: [LengthUnits, VolumeFlowRateUnits];
        rows: TabularDataTwoColumns;
    };

export type ApiResponse = "loading" | TabularData;

const SensorBase = model({
    id: identifier,
    type: string,
    timezone: string,
    latitude: number,
    longitude: number,
    owner: string,
    site: string,
})
    .volatile(() => ({
        tabularData: undefined as ApiResponse | undefined,
    }))
    .actions((self) => ({
        fetchTabular: flow(function* f(startDate: Date, endDate: Date) {
            self.tabularData = "loading";
            try {
                const data = yield fetchTabular(self.type, self.id, startDate, endDate);
                self.tabularData = data;
            } catch (e) {
                console.error('Failed to fetch tabular data', e);
                self.tabularData = undefined;
            }
        })

    }))
    .views((self) => ({
        get position(): LatLng {
            return new LatLng(self.latitude, self.longitude);
        },
        get humanId(): string | null {
            if (!self.id.includes('/')) {
                // legacy JEFDAQ ID
                return self.id;
            }

            const [proto, ...id] = self.id.split('/');
            if (proto === 'alert2') {
                return id.join(':');
            }

            if (['alert1', 'novastar'].includes(proto)) {
                return id.at(-1) || '';
            }

            if (proto === 'onerain') {
                return id.at(-2) || '';
            }

            return null;
        },
    }))
    .views((self) => ({
        distance(other: HasPosition) {
            return CRS.Earth.distance(self.position, other.position);
        },
    }))


export default SensorBase;